import { Tabs } from "antd";
import { styled } from "styled-components";

export const TabWrap = styled(Tabs)`
  height: 100%;
  overflow: hidden;

  & .ant-tabs-nav{
    margin-bottom: 0px;
  }

  & .ant-tabs-content-holder,
  & .ant-tabs-content,
  & .ant-tabs-tabpane {
    height: 100%;
    overflow: hidden;
  }

  & .ant-upload-wrapper {
    height: 100%;
    overflow: hidden;

    & .ant-upload-list {
      height: calc(100% - 50px);
      overflow: auto;
      margin-top: 10px;
    }
  }

  & td {
    height: 1px;
  }
`;